// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1miR9","modalForm":"UpgradeEpcsModal_modalForm__3Pg8J","modalFooter":"UpgradeEpcsModal_modalFooter__2EVub"};